import { render } from "./AddVehicleRoute.vue?vue&type=template&id=7acd396b"
import script from "./AddVehicleRoute.vue?vue&type=script&lang=js"
export * from "./AddVehicleRoute.vue?vue&type=script&lang=js"
script.render = render

export default script